import { useRef } from "react";

export default function MatchCard({
    name,
    age,
    note,
    match,
    tags,
    image,
    rotate = "0deg",
    handwritten,
    testid,
    tape = "left",
    className = "w-[15rem]",
}) {
    const ref = useRef(null);

    const handleMove = (e) => {
        const card = ref.current;
        if (!card) return;
        const r = card.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(1100px) rotate(${rotate}) rotateY(${
            px * 10
        }deg) rotateX(${-py * 10}deg)`;
    };
    const reset = () => {
        if (ref.current) {
            ref.current.style.transform = `perspective(1100px) rotate(${rotate}) rotateY(0deg) rotateX(0deg)`;
        }
    };

    return (
        <div
            className={`polaroid relative ${className}`}
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={reset}
            style={{ transform: `rotate(${rotate})` }}
            data-testid={testid}
        >
            <div
                className="tape"
                style={{
                    top: -10,
                    [tape]: 30,
                    transform: `rotate(${tape === "left" ? -8 : 8}deg)`,
                }}
            />
            <div className="relative w-full aspect-[4/5] overflow-hidden bg-[var(--ink)]">
                <img
                    src={image}
                    alt={`${name} profile`}
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{ filter: "saturate(0.85) contrast(1.05)" }}
                    loading="lazy"
                />
                <div className="absolute top-2 left-2 stamp text-[var(--paper)] bg-[var(--hot)] border-[var(--paper)]">
                    {match}% match
                </div>
            </div>
            <div className="pt-4 px-1">
                <div className="font-hand text-2xl text-[var(--ink)] leading-none">
                    {handwritten || `${name}, ${age}`}
                </div>
                <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[var(--ink-soft)] mt-1.5">
                    {tags.join(" · ")}
                </div>
                {note && (
                    <div className="font-hand text-base text-[var(--hot-dark)] mt-1 leading-tight">
                        "{note}"
                    </div>
                )}
            </div>
        </div>
    );
}
